<div class="popupForm" style="min-height: unset;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      <span *ngIf="state === 'articles-category-reorder'">Reorder categories</span>
      <span *ngIf="state === 'articles-reorder'">Reorder articles</span>
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content *ngIf="state === 'articles-category-reorder'"
      class="when-fx-layout-broke" style="margin: 20px 0px 20px 0px !important;">
      <div>
        <div class="example-container">
          <div
            cdkDropList
            [cdkDropListData]="listItems"
            class="example-list"
            (cdkDropListDropped)="dropArticleCategory($event)">
            <div class="example-box" *ngFor="let category of listItems; let i = index;" cdkDrag>
              {{i+1}}. {{category['group_name']}}
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-content *ngIf="state === 'articles-reorder'"
      class="when-fx-layout-broke" style="margin: 20px 0px 20px 0px !important;">
      <div cdkDropListGroup>
        <div class="example-container" *ngFor="let category of listItems; let i = index;">
          <h2>{{category['group_name']}}</h2>

          <div
            cdkDropList
            [cdkDropListData]="category['articles']"
            class="example-list"
            (cdkDropListDropped)="dropArticleItem($event)">
            <div class="example-box" *ngFor="let listItem of category['articles']; let j = index;" cdkDrag>
              {{j+1}}. {{listItem.name}}
            </div>
          </div>
        </div>
      </div>
    </mat-dialog-content>
    <!--<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">-->
      <!--<div style="font-size:12px;">-->
        <!--Tip: Use Ctrl to duplicate article between sections.-->
      <!--</div>-->
      <!--<div>-->
        <!--<button type="button" mat-button class="cancel widerButton font16">-->
          <!--Cancel-->
        <!--</button>-->
        <!--<button type="submit" class="widerButton font16" mat-raised-button color="accent">-->
          <!--OK-->
        <!--</button>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</div>
